/**
 * <theme-gallery-arrows aria-controls="carousel-id">
 * Prev/next buttons for the product gallery <media-carousel>. Dispatches the theme's own
 * `control:prev` / `control:next` events on the carousel and mirrors its edge events
 * onto the buttons' disabled state.
 */
class ThemeGalleryArrows extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const { signal } = this._abortController;
    const carousel = this.carousel;

    this.querySelectorAll("button[data-direction]").forEach((button) => {
      button.addEventListener(
        "click",
        () =>
          carousel?.dispatchEvent(
            new CustomEvent(`control:${button.dataset.direction}`, { bubbles: true, cancelable: true })
          ),
        { signal }
      );
    });

    if (carousel) {
      const prev = this.querySelector('[data-direction="prev"]');
      const next = this.querySelector('[data-direction="next"]');
      const sync = (position, disabled) => {
        const button = position === "start" ? prev : next;
        if (button) button.disabled = disabled;
      };
      carousel.addEventListener("scroll:edge-nearing", (event) => sync(event.detail.position, true), { signal });
      carousel.addEventListener("scroll:edge-leaving", (event) => sync(event.detail.position, false), { signal });
    }
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
}

if (!window.customElements.get("theme-gallery-arrows")) {
  window.customElements.define("theme-gallery-arrows", ThemeGalleryArrows);
}
